import { Directive, OnInit, inject, input } from '@angular/core';

import { ThemeInverse, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsCardHeader } from '@frontend/ui/card-header';

import { CardThemeVariant } from './types';

@Directive({
    selector: '[msThemedCardHeader]',
    standalone: true,
})
export class SportsThemedCardHeaderDirective implements OnInit {
    themedVariant = input<CardThemeVariant>();
    themedInverse = input<ThemeInverse>();
    currentTheme = injectCurrentTheme();
    cardHeader: DsCardHeader = inject(DsCardHeader, {
        self: true,
    });

    ngOnInit(): void {
        const variant = this.themedVariant()?.[this.currentTheme];
        if (variant) {
            this.cardHeader.variant.set(variant);
        }

        const inverse = this.themedInverse()?.[this.currentTheme];
        if (inverse) {
            this.cardHeader.inverse.set(inverse.isInverse);
        }
    }
}
